import { h } from 'preact';
import { registerPatternDecoder } from './index';
import { IToastOptions } from '@/components/create-toast';
import { defaultCorrectImg } from '@/assets/correct';

registerPatternDecoder(/^\{slot-correct\}/, (match, options: IToastOptions) => {
  const successImg = defaultCorrectImg;
  const correctStyle = options.customStyle?.correct ?? { width: '24px', height: '24px' };
  return <img src={successImg} alt="🪙" style={{ ...correctStyle, verticalAlign: 'middle' }} />;
});
